import classNames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../_util/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Information = props => {
  const {
    config,
    prefixClass,
    ...restProps
  } = props;
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    className: "".concat(prefixClass, "-info"),
    children: config.map((row, idx) => {
      var _row$items;
      return /*#__PURE__*/_jsxs("div", {
        className: classNames('info-record', {
          ['border-top']: !row.noBorder && idx > 0
        }),
        children: [/*#__PURE__*/_jsx("div", {
          className: "info-record--label",
          children: /*#__PURE__*/_jsx("div", {
            children: row.label
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "info-record--items",
          children: (_row$items = row.items) === null || _row$items === void 0 ? void 0 : _row$items.map((it, i) => /*#__PURE__*/_jsx("div", {
            children: it
          }, i))
        })]
      }, idx);
    })
  });
};
export default Information;